'use client';

import { useToastStore, genId, type ToasterToast } from '../_lib/toast-store';

type Toast = Omit<ToasterToast, 'id'>;

function toast({ ...props }: Toast) {
  const id = genId();
  const { addToast, updateToast, dismissToast } = useToastStore.getState();
  const update = (props: ToasterToast) => updateToast(id, props);
  const dismiss = () => dismissToast(id);

  addToast({
    ...props,
    id,
    open: true,
    onOpenChange: (open) => {
      if (!open) dismiss();
    },
  });

  return {
    id: id,
    dismiss,
    update,
  };
}

function useToast() {
  const toasts = useToastStore((state) => state.toasts);
  const dismissToast = useToastStore((state) => state.dismissToast);

  return {
    toasts,
    toast,
    dismiss: dismissToast,
  };
}

export { useToast, toast };
